import { InjectionToken } from '@angular/core';


export const MMU_SUBSIDIARY_COOKIE_NAME = new InjectionToken<string>('subsidiary', { factory: () => 'subsidiary', providedIn: 'root' });
